/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
	return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳 单位ms
 * @param {String} format 时间格式 'YYYY-MM-DD', 'MM-DD', 'YYYY-MM', 'YYYY-MM-DD hh:mm:ss'
 */
export const dateFormat = (timeStamp, format) => {
	const d = new Date(timeStamp)
	const year = d.getFullYear()
	const month = getHandledValue(d.getMonth() + 1)
	const date = getHandledValue(d.getDate())
	const hours = getHandledValue(d.getHours())
	const minutes = getHandledValue(d.getMinutes())
	const second = getHandledValue(d.getSeconds())
	const dateObj = {
		'Y+': year,
		'M+': month,
		'D+': date,
		'h+': hours,
		'm+': minutes,
		's+': second
	}
	for (let prop in dateObj) {
		if (new RegExp('(' + prop + ')').test(format)) {
			format = format.replace(RegExp.$1, dateObj[prop])
		}
	}
	return format
}

export const numberToChinese = (num) => {
	var upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿'];
	var length = (num + '').length;
	if (length == 1) {
		return upperCaseNumber[num];
	} else if (length == 2) {
		if (num == 10) {
			return upperCaseNumber[num];
		} else if (num > 10 && num < 20) {
			return '十' + upperCaseNumber[String(num).charAt(1)];
		} else {
			return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '');
		}
	}
}


/**
 * @param {String} str
 * @description 判断字符串中文字符串
 */
export const isChinese = (str) => {
	let pattern = /^[\u4E00-\u9FA5]+$/;
	return pattern.test(str);
}

/**
 * @param {String} str
 * @description 判断字符串英文字符串
 */
export const isLetter = (str) => {
	let pattern = /^[a-zA-Z]{1,16}$/g
	return pattern.test(str)
}

/**
 * @param {String} tel
 * @description 判断字符串英文字符串
 */
export const checkTel = (tel) => {
	let reg = /^(1[0-9]{10})$/
	return reg.test(tel)
}

export const checkMail = (mail) => {
	//var reyx = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
	var reyx = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
	if (mail == "" || reyx.test(mail) == false) {
		return false;
	}
	return true;
}

export const checkPassport = (text) => {
	var reg = /^[A-Z]{1}[A-Z0-9]{1}[0-9]{7}$/
	return reg.test(text)
}

/**
 * @param {String} string 源字符串
 * @param {Number} num 截取字符数量
 * @description 截取字符
 */
export const interceptChar = (string, num) => {
	if (string.length > num) return string.substr(0, num) + '...'
	return string
}

/**
 * @param {Object} obj
 * @description 获取对象长度
 */
export const objLen = (obj) => {
	return Object.keys(obj).length
}

/**
 * @param {Number} delay
 * @param {Function} callback
 * @description 本地连接search部分字符串转化为对象
 */
export const delayDev = (delay, callback) => {
	let _callback,
		_delay;
	if (Object.prototype.toString.call(delay) === 'object Function') {
		_callback = delay;
		_delay = 200;
	} else {
		_callback = callback || function () {};
		_delay = delay;
	}
	let timer = setTimeout(() => {
		_callback();
		clearTimeout(timer);
		timer = null;
	}, _delay)
};

export function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function isMobile() {
	var v = navigator.userAgent.toLowerCase()
	var result = v.match(/(ios|iphone|ipod|ipad|mobile|android|symbianos|ucweb|mqqbrowser|iemobile|webos|windows phone|windows mobile|opera mini|opera mobl|nexus|series|nokia|blackberry|meego|playbook|fennec|tablet|wechat)/) ? !0 : !1
	return result
	// return true
	// return v.match(/(ios|iphone|ipod|ipad|mobile|android|symbianos|ucweb|mqqbrowser|iemobile|webos|windows phone|windows mobile|opera mini|opera mobl|nexus|series|nokia|blackberry|meego|playbook|fennec|tablet|wechat)/) && "ontouchend" in document ? !0 : !1
}


export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

export function gioTracking(type, eventName, eventObject) {
	// console.log(type, eventName, eventObject ? JSON.stringify(eventObject): "");
	if (window && window.gio) {
		try {
			if (eventObject) {
				window.gio(type, eventName, eventObject);
			} else {
				window.gio(type, eventName);
			}
		} catch (e) {
			console.error(e);
		}
	}
}

export function gioAdsTracking(eventObject) {
	const event = {
		"adsType": eventObject.adsType || "nil",
		"bnOrder": eventObject.bnOrder || "nil",
		"lsCatOrder": eventObject.lsCatOrder || "nil",
		"lsItmOrder": eventObject.lsItmOrder || "nil",
		"chOrder": eventObject.chOrder || "nil",
		"spCode": eventObject.spCode || "nil",
		"spVideo": eventObject.spVideo || "nil",
		"spCat": eventObject.spCat || "nil",
		"rcmOrder": eventObject.rcmOrder || "nil",
		"chDes": eventObject.chDes || "nil",
		"chDesVideo": eventObject.chDesVideo || "nil",
		"topList": eventObject.topList || "nil",
		"desUrl": eventObject.desUrl || "nil"
	}
	gioTracking('track', 'evt_AdsClicked', event);
}

export function isHkSpecialCruise(shipCode, sailDate, departureCode) {
  let date = Date.parse(sailDate);
  let isHKSpecialCruise = false;
  if(date >= Date.parse("2021-10-05") && date < Date.parse("2022-01-31")){
    isHKSpecialCruise = true;
  }
  return shipCode === "SC" && isHKSpecialCruise && departureCode === "HKG";
}

export function isWechatBrowser() {
	if (!window.navigator) return false
	let ua = window.navigator.userAgent.toLowerCase();
	return ua.match(/MicroMessenger/i) === 'micromessenger';
}

export function isIOS() {
	return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
}

//文件下载
export function downloadUrlFile(url, fileName, loading) {
	const url2 = url && url.replace(/\\/g, '/');
	loading.show();
	saveAs(decodeURIComponent(url2), fileName);
	loading.hide();
}
function saveAs(url, name) {
	const urlObject = window.URL || window.webkitURL || window;
	const saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
	saveLink.href = `${url}?response-content-type=application/octet-stream;`;
	saveLink.download = name;
	saveLink.click();
	setTimeout(() => {
		urlObject.revokeObjectURL(url);
	}, 2000);
}
export function pageScroll (isShow) {
	document.body.style.overflow = isShow ? 'auto' : 'hidden';
}
export function differDays(startDate) {
	let now = new Date().getTime() / 1000;
	let endTime = new Date(startDate).getTime() / 1000 - now;
	//相差天数
	return endTime / 60 / 60 / 24;
}

/**
 * 根据日期字符串，返回时间戳
 * @param dateStr 日期字符串
 * @returns {string}
 */
export function dateStrToTimeTamp(dateStr) {
	let timeTamp = "";
	if(dateStr) {
		dateStr = dateStr.replace(/-/g, '/');
		timeTamp = new Date(dateStr).getTime();
	}
	return timeTamp;
}

/**
 * 判断是否为空
 * undefined => true
 * null => true
 * [] => true
 * {} => true
 * "" => true
 * "    " => true
 * @param target 目标
 * @returns {boolean}
 */
export function isEmpty(target) {
	if (target === undefined) return true;
	if (target === 'undefined') return true;
	if (target === null) return true;
	if (target === 'null') return true;
	if (isArray(target) && target.length === 0) return true;
	if (isObject(target) && Object.getOwnPropertyNames(target).length === 0) return true;
	if (isNumber(target) && target === -1) return true;
	if (`${target}`.trim().length === 0) return true;
	return false;
}
export function isObject(obj) {
	return Object.prototype.toString.call(obj).slice(8, -1) === 'Object';
}
export function isArray(obj) {
	return Object.prototype.toString.call(obj).slice(8, -1) === 'Array';
}
export function isNumber(obj) {
	return Object.prototype.toString.call(obj).slice(8, -1) === 'Number';
}
